var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page empty-page"},[_c('div',{staticClass:"page-toolbar"}),_c('div',{staticClass:"page-body"})])}]

export { render, staticRenderFns }